import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { QuickOrderMyCard } from "./QuickOrderMyCard";
import { QuickOrderOrderDetails } from "./QuickOrderOrderDetails";
import { MyCartSideSkeleton } from "../../../Skeleton/myCartSideSkeleton";
import { QuickOrderLineEntry } from "./QuickOrderLineEntry";
import { QuickOrderCopyPast } from "./QuickOrderCopyPast";
import { QuickOrderExcel } from "./QuickOrderExcel";
import { isValidArray } from "../../../Layout/Common/common";
import { useFlashLoaderLoader } from "../../../Context/FlashScreenContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { EbookQuickOrderLineEntry } from "../../Ebook/ebookQuickOrderLineEntry";
import { EmptyCart } from "../../../Layout/Common/emptyCart";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { showSuccessSnackbar, showWarningSnackbar } from "../../../utils/snackbarNotifications";
import { PAGES } from "../../../routeConfig";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { CartItemBody } from "../../../Layout/MainLayout/cartSidePopup/carditemBody";

export const QuickOrderMain = () => {
  const globalcontext = useContext(GlobalContext);
  const [CartItem, setCartItem] = useState(null);
  const [isClarification, setIsClarification] = useState(false);
  const { showNoteAlert } = useNoteAlert();
  const { isAuthenticated, userId, priceCode } = useAuth();
  const offcanvasRef = useRef(null);
  const closeRef = useRef(null);
  const location = useLocation();
  const path = location?.pathname?.toLowerCase() || "";
  const { addToCardQuickOrder, addToCardLineEntry, getClarificationItem } = useGlobalFunction();
  const handleNavigation = () => {
    if (offcanvasRef.current?.matches(".show, .showing")) closeRef.current.click();
  };
  useEffect(() => {
    handleNavigation();
  }, [location]);

  useEffect(() => {
    if (globalcontext.CartItem && isValidArray(globalcontext.CartItem.cartItem)) {
      setCartItem(globalcontext.CartItem);
    } else
      setCartItem({
        cartItem: [],
        orderid: 0,
        shipcost: 0,
        subtotalcost: 0,
        totalIncTax: 0,
        totalItem: 0,
        totalcost: 0,
        totaltax: 0,
      });
  }, [globalcontext.CartItem]);

  useEffect(() => {
    if (globalcontext.clarificationItem && isValidArray(globalcontext.clarificationItem)) {
      setIsClarification(true);
    } else {
      setIsClarification(false);
    }
  }, [globalcontext.clarificationItem]);

  const { showLoader, hideLoader } = useFlashLoaderLoader();

  const AddItemCart = async (data, callback, progressCallback) => {
    if (!isValidArray(data)) return;
    const chunkSize = 50;
    const errorItems = [];
    showLoader();
    let totalBatches = Math.ceil(data.length / chunkSize);
    let isBulk = data.length > chunkSize;
    if (isBulk) {
      if (progressCallback) progressCallback(0, true);
    }
    try {
      for (let i = 0; i < data.length; i += chunkSize) {
        const chunk = data.slice(i, i + chunkSize);
        const response = await addToCardQuickOrder({
          userId: userId,
          itemList: chunk,
        });
        if (response) {
          if (response.data) {
            globalcontext.setCartItem(response.data);
          }

          if (response.errorItem && response.errorItem.length > 0) {
            errorItems.push(...response.errorItem);
          }
        }
        if (isBulk && progressCallback) {
          progressCallback(Math.round(((i + chunkSize) / data.length) * 100), true);
        }
      }
      getClarificationItem("");
    } catch (err) {
      if (err && err.response && err.response.data && err.response.data.message) {
        showNoteAlert(err.response.data.message);
        setTimeout(() => closeRef.current.click(), 100);
      } else {
        showNoteAlert("Unable to add item to cart. Please try again.");
      }
    } finally {
      hideLoader();
      if (isBulk && progressCallback) {
        progressCallback(100, false);
      }
      callback(errorItems);
    }
  };

  const AddItemLineEntry = async (data, callback) => {
    if (!data) return;
    showLoader();
    const errorItems = [];
    try {
      const response = await addToCardLineEntry({
        sku: data.sku,
        qty: data.qty,
      });
      if (response) {
        if (response.errorItem) {
          errorItems.push(response.errorItem);
        }
      } else {
        showNoteAlert("Unable to add item to cart. Please try again.");
      }
    } catch (err) {
      console.error("Batch error:", err);
      if (err && err.response && err.response.data && err.response.data.message) {
        showNoteAlert(err.response.data.message);
        setTimeout(() => closeRef.current.click(), 100);
      } else {
        showNoteAlert("Unable to add item to cart. Please try again.");
      }
    } finally {
      callback(errorItems);
      hideLoader();
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end"
      id="quickOrder-popup"
      tabIndex={-1}
      ref={offcanvasRef}
      aria-labelledby="offcanvasTopLabel"
    >
      <div className="offcanvas-header cartPopup-header">
        <h5 id="offcanvasTopLabel">Quick Order</h5>
        <div className="quickorder-cart">
          <div
            className="header-user header-cart d-flex"
            data-bs-toggle="offcanvas"
            data-bs-target="#cartPopup"
            aria-controls="offcanvasTop"
          >
            <a role="button" className="cart-icon">
              <span className="wes-cart"></span>
            </a>
            <div className="header-cart">
              <a role="button">{CartItem == null ? "0" : CartItem.totalItem}</a>
            </div>
          </div>
          <p className="text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={closeRef}>
            <i className="fa-solid fa-xmark"></i>
          </p>
        </div>
      </div>
      <div className="offcanvas-body cartPopup-body">
        {/* {showProgress && (
          <div style={{ margin: "10px 0" }}>
            <div
              style={{ width: "100%", background: "#e0e0e0", borderRadius: "4px", height: "18px", overflow: "hidden" }}
            >
              <div
                style={{
                  width: `${progress}%`,
                  background: "#4caf50",
                  height: "100%",
                  transition: "width 0.3s",
                  borderRadius: "4px",
                  textAlign: "center",
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "13px",
                  lineHeight: "18px",
                }}
              >
                {progress}%
              </div>
            </div>
          </div>
        )} */}
        <div className="quickOrderList quick_orders">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-productLine-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-productLine"
                type="button"
                role="tab"
                aria-controls="pills-productLine"
                aria-selected="true"
              >
                <span className="wes-product-line"></span>
                <span className="quickCart-title">Product Line Entry</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-copyPaste-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-copyPaste"
                type="button"
                role="tab"
                aria-controls="pills-copyPaste"
                aria-selected="false"
                tabIndex="-1"
              >
                <span className="wes-copy-paste"></span> <span className="quickCart-title">Copy &amp; Paste</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-excelUpload-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-excelUpload"
                type="button"
                role="tab"
                aria-controls="pills-excelUpload"
                aria-selected="false"
                tabIndex="-1"
              >
                <span className="wes-excel-upload"></span> <span className="quickCart-title">Excel Upload</span>
              </button>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade active show"
              id="pills-productLine"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <Fragment>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <QuickOrderLineEntry AddtoCart={AddItemLineEntry} />
                    </div>
                    <div className="col-lg-12">
                      <div className="added-cartPopup quickOrder-panel p-0">
                        {!isAuthenticated ? (
                          <EmptyCart showHomeButton={false} showQuickOrderButton={true} />
                        ) : CartItem && isValidArray(CartItem.cartItem) ? (
                          <Fragment>
                            <h3 className="quickOrder-title">
                              My Cart <span>({CartItem.totalItem} Items)</span>
                            </h3>
                            <CartItemBody
                              cartItemList={CartItem.cartItem}
                              totalItem={CartItem.totalItem}
                              showToaster={false}
                            />
                          </Fragment>
                        ) : CartItem ? (
                          <EmptyCart showHomeButton={false} showQuickOrderButton={true} />
                        ) : (
                          <MyCartSideSkeleton count={3} />
                        )}
                      </div>
                    </div>
                    <QuickOrderOrderDetails />
                  </div>
                </div>
              </Fragment>
            </div>

            <div className="tab-pane fade" id="pills-copyPaste" role="tabpanel" aria-labelledby="pills-profile-tab">
              <div className="container">
                <div className="row">
                  <QuickOrderCopyPast
                    AddtoCart={AddItemCart}
                    onSuccessClose={() => closeRef.current && closeRef.current.click()}
                  />
                </div>
              </div>
            </div>

            <div className="tab-pane fade" id="pills-excelUpload" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div className="container">
                <div className="row">
                  <QuickOrderExcel
                    AddtoCart={AddItemCart}
                    onSuccessClose={() => closeRef.current && closeRef.current.click()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="offcanvas-footer quickOrder-footer">
        <div className="subtotal-btn">
          <Link to={PAGES.ORDER_DETAIL} onClick={handleNavigation} className="btn btn-products btn-unavailable">
            View Cart
          </Link>

          <div className="button-effect popup-checkout-btn">
            <Link
              onClick={handleNavigation}
              to={isClarification ? PAGES.ORDER_DETAIL : PAGES.CHECKOUT}
              className="btn btn-products btn-addcart green-btn"
            >
              Checkout
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
